import ContentIdsComponent from "modules/static-pages/content-ids/contentIds";
import Head from "next/head";
import { IQuestionAboutAutoparts } from "api/interfaces/static-pages/question-about-autoparts.type";
import commonTitleStyles from "resources/common-css/commonTitle.module.scss";
import FAQMetaHead from "../../../component/meta-header/FAQMetaHead";
import styles from "./faqs.module.scss";

const meta = {
  title: "PartsAvatar.ca: Unsure? Check our FAQs for help to find Auto Parts",
  description: "If you have any questions on buying or shipping of Auto, Car, SUV, Van, Truck repair parts online in Canada, please see our FAQs or chat or call us on phone.",
  meta: {
    robots: "all",
    name: {
      title: "See FAQs for help with Auto Parts Online Catalogue",
      keywords: "online autoparts stock ,parts orders,car parts delivery time,auto parts same day delivery,car parts customer service,vehicle parts questions help,auto part advice,find auto parts,pay for autoparts,online parts charges,auto parts cores,damaged auto parts,parts refund,parts replacement",
    },
  },
};

function FaqsContainer({ actualResponse }: IQuestionAboutAutoparts) {
  const response = actualResponse.landingPage;
  const { contentIds } = response.links;

  return (
    <div className={`container ${styles.faqs_container}`}>

      <Head>

        <title>{meta.title}</title>

        <link rel="canonical" href="https://partsavatar.ca/questions-about-autoparts" />

        <meta name="description" content={meta.description} />

        <meta name="title" content={meta.meta.name.title} />

        <meta robots={meta.meta.name.robots} />

        <meta name="keywords" content={meta.meta.name.keywords} />
      </Head>
      <FAQMetaHead contentIds={contentIds} />
      <div className={`${commonTitleStyles.common_title} ${styles.common_title}`}>Frequently Asked Questions</div>
      <ContentIdsComponent contentIds={contentIds} />

    </div>
  );
}

export default FaqsContainer;
